import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=5ee7b110&scoped=true&"
import script from "./choice.vue?vue&type=script&lang=js&"
export * from "./choice.vue?vue&type=script&lang=js&"
import style0 from "./choice.vue?vue&type=style&index=0&id=5ee7b110&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee7b110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee7b110')) {
      api.createRecord('5ee7b110', component.options)
    } else {
      api.reload('5ee7b110', component.options)
    }
    module.hot.accept("./choice.vue?vue&type=template&id=5ee7b110&scoped=true&", function () {
      api.rerender('5ee7b110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/choice.vue"
export default component.exports